const LOGIN_MODE_KEY = "managerlogix:loginMode";

function safeWindow() {
  return typeof window !== "undefined" ? window : null;
}

export function getStoredLoginMode() {
  const win = safeWindow();
  if (!win) return "";
  try {
    return String(win.sessionStorage.getItem(LOGIN_MODE_KEY) || "").trim().toLowerCase();
  } catch {
    return "";
  }
}

export function setStoredLoginMode(mode) {
  const win = safeWindow();
  if (!win) return "";
  const next = String(mode || "").trim().toLowerCase();
  try {
    if (next) win.sessionStorage.setItem(LOGIN_MODE_KEY, next);
    else win.sessionStorage.removeItem(LOGIN_MODE_KEY);
  } catch {
    return "";
  }
  return next;
}

export function clearStoredLoginMode() {
  return setStoredLoginMode("");
}
